export interface WhyUsCardContent {
  icon: string;
  title: string;
  shortDescription: string;
  fullDescription: string;
  details: string[];
}

export const whyUsCards: WhyUsCardContent[] = [
  {
    icon: "mdi:account-group",
    title: "Battle-Tested Community Builders",
    shortDescription: "Designing communities where people belong",
    fullDescription:
      "Since 2016, we have built active communities on Discord like Anthelia, which became a Discord Partner through genuine participation and consistent activity. We have helped FC Barcelona bring their cultural and sports projects to Discord, worked directly with the official developer of Geometry Dash as moderators and representatives, and hosted countless events. These experiences taught us how to create spaces where people feel connected, valued, and eager to take part.",
    details: [
      "Discord Partner achievement through genuine participation",
      "Strategic partnerships with global brands like FC Barcelona",
      "Direct collaboration with major gaming developers",
      "Proven event hosting and community activation",
      "9+ years building spaces where people belong",
    ],
  },
  {
    icon: "mdi:code-braces",
    title: "Engineering That Actually Works",
    shortDescription: "Systems that reduce friction and strengthen engagement",
    fullDescription:
      "We build systems that actually work: custom websites, reliable Discord bots, and AI tools for onboarding, moderation, analytics, and event automation. Everything we deliver reduces friction, strengthens engagement, and fits naturally into the platforms your audience already uses. No vanity metrics—just tools that make communities run better.",
    details: [
      "Custom Discord bots built for reliability and scale",
      "AI-powered onboarding and smart moderation systems",
      "Analytics that measure what actually matters",
      "Event automation that reduces manual overhead",
      "Seamless integration with platforms your audience uses",
    ],
  },
  {
    icon: "mdi:handshake",
    title: "More Than Technical Help",
    shortDescription: "Strategy, execution, and technology unified",
    fullDescription:
      "Partnering with us means more than technical help. You gain a team that has done it before, one that aligns strategy, execution, and technology to grow your community sustainably. We deliver clear processes, measurable results, and a human touch that keeps people coming back.",
    details: [
      "Strategic alignment from day one",
      "Clear processes and measurable results",
      "Sustainable growth without burning out your team",
      "Systems designed to scale while staying personal",
      "A proven partner who's been in the trenches",
    ],
  },
];
